// extracted by mini-css-extract-plugin
module.exports = {"message":"mailing-address-message_message__2yPIY"};